import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap'; // Import Button component from react-bootstrap
import Styles from './infoSection.module.scss';
import healthImage from '../../assets/health.webp'; // Import the image using require

const InfoSection = () => {
  const navigate = useNavigate();

  const navigateToHealth = () => {
    navigate('/health');
  };

  return (
    <div className={Styles.informationSec}>
      <div className={Styles.image}>
        <img className={Styles.informationSecImage} src={healthImage} alt="Health" />
      </div>
      <div className={Styles.textContainer}>
        <div className={Styles.informationSecText}>
          <h1>Health and Precautions</h1>
          <p>
            Health and precautions are paramount for well-being. Ensure good health by practicing regular handwashing, maintaining social distance, and wearing masks in crowded places. Stay informed about local guidelines and prioritize your safety.
          </p>
          <div onClick={navigateToHealth}>
            <Button variant="secondary" className={Styles.informationSecButton}>
              Read More
            </Button>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export {InfoSection};
